import React, {Component} from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import ShopPanel from "./EditAttachmentDialog/ShopPanel"
import SelectShopDialog from "../../../shop/SelectShopDialog"

/**
 * attachment
 * 
 * onSaveClick(attachment)
 * onCancelClick
 */

class EditAttachmentDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            quantity: String(this.props.attachment.quantity),
            shop: this.props.attachment.shop,
        }
    }

    readyToCreate = () => {
        if (!this.state.quantity.length) {
            return false
        }
        if (isNaN(Number(this.state.quantity))) {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog open fullWidth>
            <DialogTitle>{this.props.attachment.item.name}</DialogTitle>
            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                <TextField
                    value = {this.state.quantity}
                    label = "Количество предметов"
                    margin = "normal"
                    onChange = {e => {
                        e.preventDefault()
                        this.setState({quantity: e.target.value})
                    }}
                />
                <ShopPanel 
                    title = "Магазин"
                    shop = {this.state.shop}
                    onSelectShopClick = {() => {
                        this.setState({
                            dialog: <SelectShopDialog
                                item_shops = {this.props.attachment.item.shops ? this.props.attachment.item.shops : undefined}
                                onSelectClick = {shop => {
                                    this.setState({
                                        dialog: undefined,
                                        shop: shop,
                                    })
                                }}
                                onCancelClick = {() => this.setState({dialog: undefined})}
                            />
                        })
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {!this.readyToCreate()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onSaveClick === "function") {
                            let attachment = global.structuredClone(this.props.attachment)
                            attachment.quantity = this.state.quantity
                            attachment.shop = this.state.shop
                            attachment.shop_id = this.state.shop ? this.state.shop.id : undefined
                            this.props.onSaveClick(attachment)
                        }
                    }}
                >Сохранить</Button>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default EditAttachmentDialog